import axios from 'axios';
import queryString from 'query-string';

import { env } from 'env';
import { SELECTED_ENTITY, USER_ID } from 'types';

// Please have a look at here `https://github.com/axios/axios#request-config` for the full list of configs
const { CancelToken } = axios;
export const sourceCancel = CancelToken.source();

const baseURLStock = `${env.service.stockService}/api/v1`;

// entity service
const stockService = axios.create({
  baseURL: baseURLStock,
  cancelToken: sourceCancel.token,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer: params => queryString.stringify(params),
});

stockService.interceptors.response.use(
  response => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  error => {
    if (
      error.response.data?.message === 'Invalid access domain' &&
      error.response.status === 403
    ) {
      localStorage.removeItem(USER_ID);
      localStorage.removeItem(SELECTED_ENTITY);
      updateTokenBearer('');
      window.location.replace('/admin');
    }
    throw error;
  }
);

export const getTokenBearer = () =>
  stockService.defaults.headers.common.Authorization;

export const updateTokenBearer = token => {
  stockService.defaults.headers.common.Authorization = token;
};

export const updateTokenID = token => {
  stockService.defaults.headers.common['token-id'] = token;
};

export const updateCurrentEntityStock = (entityID, type) => {
  stockService.defaults.headers.common['entity-id'] = entityID;
  stockService.defaults.headers.common.type = type;
};

export const removeCurrentEntityStock = () => {
  delete stockService.defaults.headers.common['entity-id'];
  delete stockService.defaults.headers.common.type;
};

export const updateUserAgent = (content: string): void => {
  stockService.defaults.headers.common['user-agent-hub'] = content;
};

export const removeUserAgent = (): void => {
  const value = stockService.defaults.headers.common['user-agent-hub'];
  delete stockService.defaults.headers.common['user-agent-hub'];
  return value;
};

export const updateBaseURL = (url: string): void => {
  stockService.defaults.baseURL = url;
};

export default stockService;
